import React, { Component } from 'react';
import axios from 'axios';
import Navbar from './NavbarScanner';
// import Sidebar from './SidebarScanner';
import Sidebar from "./Sidebar"
import LoaderRounded from "./LoaderRounded";
import { connect } from "react-redux";
import ReactPaginate from 'react-paginate';
import * as actions from "./../actions/authAction";

class NewScannedList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allpaymentData: [],
            errors: [],
            yin_id: "",
            mobile: "",
            searchTitle: "",
            documentsPerPage: 10,
            selectedPage: 1,
            loader: true,
            showModalPopup: false,
            noOfPages: 0
        }

        this.handlePageChange = this.handlePageChange.bind(this);
    }

    handlePageChange(page) {
        const selectedPage = page.selected + 1;
        this.setState({ selectedPage });
        this.getData(selectedPage, this.state.yin_id, this.state.mobile);
    }

    componentDidMount() {
        this.getData();
    }

    getData(page = 1, yin_id = "", mobile = "") {
        this.setState({ loader: true });

        const requestBody = {
            searchTitle: this.state.searchTitle || "",
            documentsPerPage: this.state.documentsPerPage || 10,
            page: page,
            yin_id: yin_id,
            mobile: mobile
        };

        axios.post(process.env.REACT_APP_APIURL + `/subscription/readPGN`, requestBody)
            .then(res => {
                console.log("response", res)
                this.setState({
                    allpaymentData: res?.data || [],
                    loader: false,
                    noOfPages: res?.data?.noOfPages || 0
                });
            })
            .catch(err => {
                console.error("Error fetching data:", err);
                this.setState({ loader: false });
            });
    }

    render() {
        const { allpaymentData, loader, documentsPerPage } = this.state;

        return (
            <>
                <Sidebar />
                <div className="main">
                    <div className="topbar">
                        <Navbar />
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <u><h2 className="text-center divider-20">Scanned List</h2></u>
                                <br />
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="table-responsive-sm">
                                    <table className="table table-bordered table-responsive">
                                        <thead>
                                            <tr>
                                                <th>Sr No</th>
                                                <th>Full Name</th>
                                                <th>Membership Plan</th>
                                                <th>Claimed Rewards</th>
                                                <th>Subscription Status</th>
                                                <th>Transaction Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loader ? (
                                                <tr>
                                                    <td colSpan={5} className="text-center"><LoaderRounded /></td>
                                                </tr>
                                            ) : allpaymentData?.data && allpaymentData?.data?.length > 0 ? (
                                                allpaymentData?.data?.map((item, index) => {
                                                    const rewards = item.claimedRewards || {};
                                                    const rewardList = [];
                                                    if (rewards.bag) rewardList.push("Bag");
                                                    if (rewards.bottle) rewardList.push("Bottle");
                                                    if (rewards.kit) rewardList.push("Kit");

                                                    return (
                                                        <tr key={index}>
                                                            <td>{(this.state.selectedPage - 1) * this.state.documentsPerPage + index + 1}</td>
                                                            <td>{item.fullName}</td>
                                                            <td>{item.membershipPlan}</td>
                                                            <td>{rewardList.join(", ") || "-"}</td>
                                                            <td>{item.subscriptionstatus}</td>
                                                            <td>{item.transectionStatus}</td>
                                                        </tr>
                                                    )
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={5} className="text-center">No data found...</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="overflow-auto mt-2">
                        <ReactPaginate
                            nextLabel="Next"
                            previousLabel="Previous"
                            pageCount={this.state.noOfPages}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            containerClassName="pagination"
                            activeClassName="btn btn-primary"
                            pageClassName="btn"
                            previousClassName="btn"
                            nextClassName="btn"
                            onPageChange={this.handlePageChange}
                        />
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {};
}

const mapDispatchToProps = (dispatch) => {
    return {
        login: (data) => dispatch(actions.loginSuccess(data)),
        mobile: (data) => dispatch(actions.adminmobile(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewScannedList);
